import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router";
import useQuery from "./useQuery";

export default function useImageLightboxParam() {
  const navigate = useNavigate();
  const location = useLocation();
  const imageId = useQuery().get("image");

  const openImage = useCallback(
    id => {
      const params = new URLSearchParams(location.search);
      params.set("image", id);
      navigate({ search: params.toString() });
    },
    [location.search, navigate]
  );

  const closeImage = useCallback(() => {
    const params = new URLSearchParams(location.search);
    params.delete("image");
    navigate({ search: params.toString() });
  }, [location.search, navigate]);

  return { imageId, openImage, closeImage };
}
